import { Api } from 'models/services/api';
import { ReadCompaniesQuery } from 'models/services/graphql';

import { CompanyCollectionData } from '../collection';

type DataToRead = {
  nextToken?: string;
};

const RequestQuery = `
  query ReadCompanies($nextToken: String) {
    ${ReadCompaniesQuery}
  }
`;

type ResponseData = {
  data: {
    readCompanies: CompanyCollectionData;
  }
}

class ReadCollectionGql {

  readonly result?: CompanyCollectionData;
  private readonly api: Api<ResponseData>;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToRead = {}): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const result = api.response.data.readCompanies;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result, api });
  }

}

export { ReadCollectionGql };
